.container {
  display: flex;
  flex-direction: column;
  gap: 0.8rem;
  position: relative;
  flex: 1;
}

.label {
  font-weight: 400;
  color: var(--color-grayscale-white);
  font-size: 1.4rem;
}

.error {
  position: absolute;
  right: 0;
  bottom: -1.4rem;
  color: var(--color-error);
  font-family: Inter, sans-serif;
  font-size: 1rem;
  letter-spacing: -0.2px;
  text-align: right;
}
